/* GET SINGLE SOFT SKILL COURSE */
export const GET_SOFTSKILLS_COURSE = "GET_SOFTSKILLS_COURSE"
export const GET_SOFTSKILLS_COURSE_SUCCESS = "GET_SOFTSKILLS_COURSE_SUCCESS"
export const GET_SOFTSKILLS_COURSE_CLEAN = "GET_SOFTSKILLS_COURSE_CLEAN"
export const GET_SOFTSKILLS_COURSE_ERROR = "GET_SOFTSKILLS_COURSE_ERROR"
